<template>
	<li class="nav-link A2HSInstallPrompt" v-if="showInstallBanner">
		<a href="#" class="nav-item dropdown-item" @click.prevent="install">Установить Reactor</a>
	</li>
</template>

<script>
	let installEvent;
	export default {
		name: 'A2HSInstallPrompt',
		components: {

		},
		props: {
			counter: String,
			findId: { //это свойсво удалять не надо, оно хорошее и моет быть использовано в опуиях для формпринтера или фильтрпринтера
				type: String,
				default: '',
			},
		},
		data () {
			return {
				ver: 1,
				showInstallBanner: false,
			}
		},
		computed: {

		},
		methods: {
			install() {
				this.showInstallBanner = false;
				installEvent.prompt();
				installEvent.userChoice.then(() => {
					installEvent = null;
				});
			}
		},
		created() {
			window.addEventListener('beforeinstallprompt', e => {
				e.preventDefault();
				installEvent = e;
				this.showInstallBanner = true;
			});
		},
	}
</script>
<style scoped>

</style>
